// @general/support - frontend surface.

export { supportApi, browserContext } from './api'
export { statusVariant, priorityVariant, parseStatusNote } from './labels'
export { default as NewTicketModal } from './components/NewTicketModal.vue'

export const routes = [
  {
    path: '/support',
    name: 'support',
    component: () => import('./views/SupportView.vue'),
    meta: { title: 'support.title' },
  },
  {
    path: '/support/:id',
    name: 'support-ticket',
    component: () => import('./views/SupportTicketView.vue'),
    meta: { title: 'support.title' },
  },
]

// No permission on the entry: everybody with an account can ask for help, and a
// help link that is only visible to some people is the reason support arrives by
// WhatsApp.
//
// It sits in `platform` because that is whose screen it is, and the sidebar is
// split by ownership. What keeps it findable is `order`: second in the block,
// right under Notifications, so opening the section puts it under the cursor
// rather than at the bottom of a list of eight.
export const navigation = [
  { to: '/support', labelKey: 'support.title', icon: 'lifebuoy', group: 'platform', order: 20 },
]

export default { routes, navigation }
